<template>
<div class="l-star">
  <span :class="{show: item <= star}" :key="(item)" v-for="item in 5" class="l-img"></span>
</div>
</template>

<script>
export default {
  name: "star",
  props: ['options'],
  data(){
    return{
      star: 0,
    }
  },
  watch:{
    options: {
      handler(val) {
        this.star = Number(val);
      },
      deep: true,
      immediate: true,
    },
  }
}
</script>

<style lang="stylus" scoped>
@import "./star.styl";
</style>
